'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { Avatar, type AvatarSize } from '@morpho-org/ui-v6/components/client/Avatar';
import { HoverableCell } from '@morpho-org/ui-v6/components/client/HoverableCell';
import { cn } from '@morpho-org/ui-v6/utils';
import { getCuratorUrl } from '@/helpers/routing';
import { useNetworkNavigation } from '@/hooks/useNetworkNavigation';
import { RiskCuratorCardContent } from '../../RiskCuratorCard';
export interface RiskCuratorCellProps {
  curators?: {
    id: string;
    name: string;
    image: string | null;
    state?: {
      aum: number;
    } | null;
  }[];
  textClassName?: string;
  isHoverable?: boolean;
  withLabel?: boolean;
  chainId: ChainId | null;
  logoSize?: AvatarSize;
}
const RiskCuratorCell = t0 => {
  const $ = _c(17);
  const {
    curators,
    textClassName: t1,
    isHoverable: t2,
    withLabel: t3,
    chainId,
    logoSize: t4
  } = t0;
  const textClassName = t1 === undefined ? "text-xs" : t1;
  const isHoverable = t2 === undefined ? true : t2;
  const withLabel = t3 === undefined ? true : t3;
  const logoSize = t4 === undefined ? "medium" : t4;
  const {
    navigateTo
  } = useNetworkNavigation();
  if (!curators || curators.length === 0) {
    return null;
  }
  let t5;
  if ($[0] !== chainId || $[1] !== curators || $[2] !== isHoverable || $[3] !== logoSize || $[4] !== navigateTo || $[5] !== textClassName || $[6] !== withLabel) {
    let t6;
    if ($[8] !== chainId || $[9] !== isHoverable || $[10] !== logoSize || $[11] !== navigateTo || $[12] !== textClassName || $[13] !== withLabel) {
      t6 = curator => {
        const {
          name,
          image
        } = curator;
        return <HoverableCell key={curator.id} hoverCardContent={<RiskCuratorCardContent curator={curator} chainId={chainId} />} isDisabled={!isHoverable} hoverCardContentProps={{
          style: {
            minWidth: 300,
            maxWidth: 400
          },
          side: "bottom"
        }}><div className="gap-xs flex items-center" onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            navigateTo(getCuratorUrl({
              curatorId: curator.id
            }));
          }}><Avatar src={image} size={logoSize} />{withLabel && <span className={cn("text-foreground leading-normal", textClassName)}>{name}</span>}</div></HoverableCell>;
      };
      $[8] = chainId;
      $[9] = isHoverable;
      $[10] = logoSize;
      $[11] = navigateTo;
      $[12] = textClassName;
      $[13] = withLabel;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = curators.map(t6);
    $[0] = chainId;
    $[1] = curators;
    $[2] = isHoverable;
    $[3] = logoSize;
    $[4] = navigateTo;
    $[5] = textClassName;
    $[6] = withLabel;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <div className="gap-2xs flex items-center">{t5}</div>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default RiskCuratorCell;